module.exports = __webpack_public_path__ + "img/基于场景的产品与服务@2x.60d125b7.png";